import { action } from '@/lib/api.js';
import { store } from '@/redux/lib/configureStore.js';
import setQuery from '@/lib/setQuery.js';
import { query } from '@/redux/selectors/querySelectors';
import { workflowStepTabMemory } from '@/screens/workflows/redux/selectors/workflowScreenSelectors.js';
import buildWorkflowStepSelectionQuery from '@/screens/workflows/lib/buildWorkflowStepSelectionQuery.js';

const setActiveSteps = ({ steps = [], clear = false, replace }) => {
  const state = store.getState();
  const selectedSteps = state?.workflow?.selectedSteps;
  const stepId = query(state, 'stepId');
  const stepTab = query(state, 'stepTab');

  const noChange = steps?.join('|') === selectedSteps?.join('|') && selectedSteps?.includes(stepId);
  if (noChange) {
    return;
  }

  if (steps?.length < 1 && !clear) {
    return;
  }

  action('SET_WORKFLOW_SELECTED_STEPS', steps);
  const newStepId = steps?.length !== 1 ? null : steps?.[0];
  if (newStepId === stepId) {
    return;
  }

  if (stepId && stepTab) {
    action('SET_WORKFLOW_STEP_TAB_MEMORY', { stepId, tabKey: 'stepTab', value: stepTab });
  }

  const nextStepTab = newStepId ? workflowStepTabMemory(state, { stepId: newStepId, tabKey: 'stepTab' }) : null;
  const queryValues = buildWorkflowStepSelectionQuery({
    currentQuery: query(state),
    nextStepId: newStepId,
    nextStepTab
  });

  setQuery(queryValues, replace === undefined ? undefined : { replace });
};

export default setActiveSteps;
